<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Chapter-rw" epub:type="bodymatter chapter" id="chapter014">
<h1 class="toc-title">Contents</h1>
<p class="toc-front" id="cover"><span href="#/cover" title="Link target outside of Sample">Cover</span></p>
<p class="toc-front" id="titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc-front" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-front" id="toc-dedication"><a href="#/dedication">Dedication</a></p>
<p class="toc-preface" id="toc-preface002"><a href="#/preface002">Epigraph</a></p>
<p class="toc-preface" id="toc-preface004"><a href="#/preface004">Map</a></p>
<p class="toc-part" id="toc-part001"><a href="#/part001">PART ONE</a></p>
<p class="toc-chapter" id="toc-chapter001"><a href="#/chapter001">CHAPTER ONE: Coltsfoot</a></p>
<p class="toc-chapter" id="toc-chapter002"><a href="#/chapter002">CHAPTER TWO: Furze</a></p>
<p class="toc-chapter" id="toc-chapter003"><span href="#/chapter003" title="Link target outside of Sample">CHAPTER THREE: Ragwort</span></p>
<p class="toc-chapter" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">CHAPTER FOUR: Ash</span></p>
<p class="toc-chapter" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">CHAPTER FIVE: Alder</span></p>
<p class="toc-part" id="toc-part002"><span href="#/part002" title="Link target outside of Sample">PART TWO</span></p>
<p class="toc-chapter" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">CHAPTER SIX: Nettle</span></p>
<p class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">CHAPTER SEVEN: Dock</span></p>
<p class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">CHAPTER EIGHT: Yarrow</span></p>
<p class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">CHAPTER NINE: Selfheal</span></p>
<p class="toc-chapter" id="toc-chapter010"><span href="#/chapter010" title="Link target outside of Sample">CHAPTER TEN: Hogweed</span></p>
<p class="toc-chapter" id="toc-chapter011"><span href="#/chapter011" title="Link target outside of Sample">CHAPTER ELEVEN: Foxglove</span></p>
<p class="toc-chapter" id="toc-chapter012"><span href="#/chapter012" title="Link target outside of Sample">CHAPTER TWELVE: Germander speedwell</span></p>
<p class="toc-chapter" id="toc-chapter013"><span href="#/chapter013" title="Link target outside of Sample">CHAPTER THIRTEEN: Devil's-bit scabious</span></p>
<p class="toc-chapter" id="toc-chapter014"><span href="#/chapter014" title="Link target outside of Sample">CHAPTER FOURTEEN: Hart's tongue</span></p>
<p class="toc-chapter" id="toc-chapter015"><span href="#/chapter015" title="Link target outside of Sample">CHAPTER FIFTEEN: Oak</span></p>
<p class="toc-chapter" id="toc-chapter016"><span href="#/chapter016" title="Link target outside of Sample">CHAPTER SIXTEEN: Yellow iris</span></p>
<p class="toc-part" id="toc-part003"><span href="#/part003" title="Link target outside of Sample">PART THREE</span></p>
<p class="toc-chapter" id="toc-chapter017"><span href="#/chapter017" title="Link target outside of Sample">CHAPTER SEVENTEEN: Bramble</span></p>
<p class="toc-chapter" id="toc-chapter018"><span href="#/chapter018" title="Link target outside of Sample">CHAPTER EIGHTEEN: Whitethorn</span></p>
<p class="toc-chapter" id="toc-chapter019"><span href="#/chapter019" title="Link target outside of Sample">CHAPTER NINETEEN: Mint</span></p>
<p class="toc-chapter" id="toc-chapter020"><span href="#/chapter020" title="Link target outside of Sample">CHAPTER TWENTY: Elder</span></p>
<p class="toc-chapter" id="toc-chapter021"><span href="#/chapter021" title="Link target outside of Sample">CHAPTER TWENTY-ONE: Heather</span></p>
<p class="toc-chapter1" id="toc-appendix001"><span href="#/appendix001" title="Link target outside of Sample">Author’s Note</span></p>
<p class="toc-appendix" id="toc-acknowledgements"><span href="#/acknowledgements" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc-appendix"><a href="#/discoverpage">Discover More Hannah Kent</a></p>
<p class="toc-appendix" id="toc-personblurb"><span href="#/personblurb" title="Link target outside of Sample">About the Author</span></p>
<p class="toc-preface" id="toc-ad-card"><a href="#/adcard">Also by Hannah Kent</a></p>
<p class="toc-preface" id="toc-praise"><span href="#/praise" title="Link target outside of Sample">Praise for Hannah Kent’s <em>The Good People</em></span></p>
<p class="toc-preface" id="toc-appendix002"><span href="#/appendix002" title="Link target outside of Sample">Questions and Topics for Discussion</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?f1df7bee